import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {setActiveTabs} from 'app/top-tabs-reduser';
import {useAppSelector} from "common/hook";

SwiperCore.use([Navigation, Pagination]);

export const TestTabs = () => {
    const dispatch = useDispatch();
    const swiperRef = useRef<SwiperCore | null>(null);
    const activeTab = useAppSelector((state) => state.topTabs.activeTabs);

    const tabs = [
        { id: 0, label: 'Мои тесты' },
        { id: 1, label: 'Тесты от учителей' },
    ];

    const handleTabClick = (index: number) => {
        if (activeTab.includes(index)) {
            return;
        }

        const newActiveTabs = [index];
        dispatch(setActiveTabs(newActiveTabs));
        swiperRef.current?.slideTo(newActiveTabs[0]);
    };


    useEffect(() => {
        return () => {
            // Сброс активного таба при размонтировании компонента
            dispatch(setActiveTabs([0]));
        };
    }, [dispatch]);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.on('slideChange', () => {
                dispatch(setActiveTabs([swiperRef.current?.activeIndex ?? 0]));
            });
        }
    }, [dispatch]);

    return (
        <Swiper
            slidesPerView={'auto'}
            loop={false}
            spaceBetween={0}
            watchOverflow={true}
            className="tabs-nav"
            onSwiper={(swiper) => {
                swiperRef.current = swiper;
            }}
        >
            <div className="swiper-container">
                <div className="swiper-wrapper">
                    {tabs.map((tab) => (
                        <SwiperSlide
                            key={tab.id}
                            className={`swiper-slide ${activeTab[0] === tab.id ? 'active' : ''}`}
                            onClick={() => handleTabClick(tab.id)}
                        >
                            <span className={`tab-nav-item ${activeTab[0] === tab.id ? 'active' : ''}`}>
                                {tab.label}
                            </span>
                        </SwiperSlide>
                    ))}
                </div>
            </div>
            {tabs.map((tab) => (
                activeTab.includes(tab.id) && (
                    <div key={tab.id} className={`tab-content ${activeTab[0] === tab.id ? 'active' : ''}`} />
                )
            ))}
        </Swiper>
    );
};
